var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArtist(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5072_209)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z",
    fill: "#00C8C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 20C40 18.8635 39.9052 17.7491 39.7231 16.6644L28.9541 5.89545L26.4571 11.424L8.63385 29.2401L19.3844 39.9907C19.5889 39.9969 19.7941 40 20 40C31.0457 40 40 31.0457 40 20Z",
    fill: "#13AAAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6799 24.9078H28.8475C30.275 24.9078 31.477 23.8405 31.6464 22.423C31.7161 21.8397 31.7474 21.2444 31.7377 20.6401C31.623 13.4715 25.8264 7.77179 18.6568 7.77179C11.4265 7.77179 5.56607 13.6373 5.57435 20.8697C5.58255 28.0126 11.3876 33.8687 18.5302 33.9363C18.5706 33.9367 18.611 33.9369 18.6513 33.9369C20.2077 33.9376 21.4693 32.6748 21.4693 31.1184C21.4694 27.6884 24.2499 24.9078 27.6799 24.9078Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0565 7.8457V33.5614C20.9007 33.0745 21.4693 32.1629 21.4693 31.1184C21.4693 27.6884 24.2499 24.9078 27.6799 24.9078H28.8475C30.275 24.9078 31.477 23.8405 31.6464 22.423C31.7161 21.8397 31.7474 21.2445 31.7377 20.6402C31.6306 13.9445 26.5663 8.53086 20.0565 7.8457Z",
    fill: "#E9EDF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4239 16.33C14.7787 16.33 15.8769 15.2318 15.8769 13.877C15.8769 12.5223 14.7787 11.4241 13.4239 11.4241C12.0692 11.4241 10.9709 12.5223 10.9709 13.877C10.9709 15.2318 12.0692 16.33 13.4239 16.33Z",
    fill: "#7584F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5252 30.9896C16.88 30.9896 17.9782 29.8913 17.9782 28.5366C17.9782 27.1819 16.88 26.0836 15.5252 26.0836C14.1705 26.0836 13.0723 27.1819 13.0723 28.5366C13.0723 29.8913 14.1705 30.9896 15.5252 30.9896Z",
    fill: "#707789"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1533 24.4755C11.508 24.4755 12.6063 23.3772 12.6063 22.0225C12.6063 20.6678 11.508 19.5695 10.1533 19.5695C8.79855 19.5695 7.70032 20.6678 7.70032 22.0225C7.70032 23.3772 8.79855 24.4755 10.1533 24.4755Z",
    fill: "#A3D4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6214 15.0217C22.9762 15.0217 24.0744 13.9235 24.0744 12.5688C24.0744 11.214 22.9762 10.1158 21.6214 10.1158C20.2667 10.1158 19.1685 11.214 19.1685 12.5688C19.1685 13.9235 20.2667 15.0217 21.6214 15.0217Z",
    fill: "#FFCE00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1859 34.1769C27.5691 34.1769 27.0587 33.7281 27.0206 33.1523L25.7914 14.5663C25.7295 13.6304 26.5244 12.8395 27.527 12.8395H28.845C29.8476 12.8395 30.6424 13.6304 30.5805 14.5663L29.3513 33.1523C29.3132 33.7281 28.8027 34.1769 28.1859 34.1769Z",
    fill: "#FE6A16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8449 12.8396H28.1513V34.1753C28.1629 34.1756 28.1742 34.1769 28.1858 34.1769C28.8027 34.1769 29.3131 33.7281 29.3512 33.1523L30.5804 14.5663C30.6423 13.6304 29.8475 12.8396 28.8449 12.8396Z",
    fill: "#F24500"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7613 10.9449C30.7613 12.3673 29.6082 13.5203 28.1859 13.5203C26.7635 13.5203 25.6105 12.3673 25.6105 10.9449C25.6105 9.52258 26.7635 5.51367 28.1859 5.51367C29.6082 5.51367 30.7613 9.52266 30.7613 10.9449Z",
    fill: "#555A66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.186 5.51373C28.1744 5.51373 28.1629 5.51475 28.1514 5.5153V13.5195C28.163 13.5197 28.1744 13.5204 28.186 13.5204C29.6083 13.5204 30.7613 12.3673 30.7613 10.945C30.7613 9.52264 29.6083 5.51373 28.186 5.51373Z",
    fill: "#333940"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5072_209"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArtist);
export default __webpack_public_path__ + "static/media/artist.17fededefe388d0e32a47f10f3083645.svg";
export { ForwardRef as ReactComponent };